export default __webpack_public_path__ + "static/media/work3image2.eaa7562a.png";